// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStkstataweth } from "../../../icons/mono/build/icon-stkstataweth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StkstatawethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStkstataweth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StkstatawethIcon.displayName = 'StkstatawethIcon';
}

export default StkstatawethIcon;